import React, { useState } from "react";
import { Link } from "react-router-dom";
import Grain from "../Grain/Grain";
import { WHATSAPP_URL } from "../../Constants/constants";
import { COMPANY, SOCIAL_LINKS } from "../../data/siteContent";
import { useAppLinks } from "../../hooks/useAppLinks";
import "./styles.css";

const SITEMAP = [
  { id: "hero", label: "Início" },
  { id: "agents", label: "Como funciona" },
  { id: "numbers", label: "Resultados" },
  { id: "testimonials", label: "Depoimentos" },
  { id: "security", label: "Segurança" },
  { id: "pricing", label: "Planos" },
];

const PRODUCT = [
  { id: "agents", label: "Pedido cirúrgico" },
  { id: "agents", label: "Pacotes de OPME" },
  { id: "agents", label: "Voz e OCR" },
  { id: "pricing", label: "Empresarial" },
];

const Seal = ({ title, subtitle, children }) => (
  <div className="seal">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      {children}
    </svg>
    <div>
      <b>{title}</b>
      <span>{subtitle}</span>
    </div>
  </div>
);

const Footer = () => {
  const links = useAppLinks();
  const [barHeights] = useState(() => Array.from({ length: 46 }, () => 38 - Math.round(Math.random() * 22)));

  return (
    <footer className="footer">
      <Grain variant="hard" />
      <div className="container">
        <div className="footer-grid">
          <div className="col brand">
            <Link to="/#hero" className="logo">
              LetsDoc<b>.</b>
            </Link>
            <p>A plataforma de IA que escreve o pedido cirúrgico por você.</p>
            <div className="sig">
              Menos burocracia
              <br />
              Mais cirurgia
            </div>
            <div className="barcode" aria-hidden="true">
              {barHeights.map((height, i) => (
                <i key={i} style={{ height }} />
              ))}
            </div>
            <div className="seals">
              <Seal title="LGPD" subtitle="Em conformidade">
                <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z" />
                <path d="m9 12 2 2 4-4" />
              </Seal>
              <Seal title="SSL" subtitle="Conexão criptografada">
                <rect x="4" y="11" width="16" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
              </Seal>
              <Seal title="CFM" subtitle="Segue as resoluções">
                <rect x="5" y="3" width="14" height="18" rx="2" />
                <path d="M9 8h6M9 12h6M9 16h3" />
              </Seal>
            </div>
          </div>

          <div className="col">
            <h4>Redes</h4>
            {SOCIAL_LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                {...(href !== "#" && { target: "_blank", rel: "noopener noreferrer" })}
              >
                {label}
              </a>
            ))}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
          </div>

          <div className="col">
            <h4>Sitemap</h4>
            <a href={links.login}>Entrar</a>
            {SITEMAP.map(({ id, label }) => (
              <Link key={label} to={`/#${id}`}>
                {label}
              </Link>
            ))}
          </div>

          <div className="col">
            <h4>Produto</h4>
            {PRODUCT.map(({ id, label }) => (
              <Link key={label} to={`/#${id}`}>
                {label}
              </Link>
            ))}
          </div>

          <div className="col">
            <h4>Legal</h4>
            <Link to="/terms">Termos de uso</Link>
            <Link to="/privacy-policy">Política de privacidade</Link>
            <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{COMPANY.copyright}</span>
          <span>
            {COMPANY.legalName} CNPJ {COMPANY.cnpj}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
